// Archieved for Refinement
// import * as Note from '@/services/rest-api/lib/delivery/note'

const translate = (t, key, fallback, params = {}) => {
  if (typeof t !== 'function') return fallback

  const translated = t(key, params)

  return translated === key ? fallback : translated
}

const getDraftFields = (t) => [
  // Archieved for Refinement
  // {
  //   name: 'delivery_notes',
  //   type: 'select-resourceful',
  //   label: 'Catatan Pengiriman',
  //   optionsGetter: Note.get,
  //   optionLabelFn: ({ item }) => item.note,
  //   trackBy: 'note',
  //   // naming using array because it's not getting an object
  //   getInitialArray: (showResponse) => {
  //     if (!showResponse?.delivery_notes) return
  //     return showResponse.delivery_notes.map((item) => {
  //       return { id: '', note: item }
  //     })
  //   },
  //   placeholder: 'Pilih Catatan Pengiriman',
  //   multiple: true,
  //   taggable: true,
  // },
  {
    name: 'customer_notes',
    type: 'select-resourceful',
    label: translate(t, 'delivery.noteField.customerSpecial', 'Catatan Khusus Pelanggan'),
    optionsGetter: null, // Null because we will define the getter in form
    optionLabelFn: ({ item }) => item.note,
    getInitialArray: (showResponse) => {
      if (!showResponse?.customer_notes) return
      return showResponse.customer_notes.map((item) => {
        return { id: '', note: item }
      })
    },
    trackBy: 'note',
    placeholder: translate(
      t,
      'delivery.noteField.selectCustomerSpecial',
      'Pilih Catatan Khusus Pelanggan'
    ),
    multiple: true,
    taggable: true,
  },
  {
    key: 'note',
    name: 'note',
    label: translate(t, 'delivery.noteField.other', 'Catatan Lainnya'),
    placeholder: translate(
      t,
      'delivery.noteField.enterOther',
      'Masukkan catatan lainnya disini...'
    ),
    type: 'textarea',
    validation: 'max:255,length',
  },
]

const getStartedFields = (t) => [
  // Archieved for Refinement
  // {
  //   name: 'delivery_notes',
  //   type: 'select-resourceful',
  //   label: 'Catatan Pengiriman',
  //   optionsGetter: Note.get,
  //   optionLabelFn: ({ item }) => item.note,
  //   trackBy: 'note',
  //   // naming using array because it's not getting an object
  //   getInitialArray: (showResponse) => {
  //     if (!showResponse?.delivery_notes) return
  //     return showResponse.delivery_notes.map((item) => {
  //       return { id: '', note: item }
  //     })
  //   },
  //   placeholder: 'Pilih Catatan Pengiriman',
  //   multiple: true,
  //   taggable: true,
  //   disabled: true,
  // },
  {
    name: 'customer_notes',
    type: 'select-resourceful',
    label: translate(t, 'delivery.noteField.customerSpecial', 'Catatan Khusus Pelanggan'),
    optionsGetter: null, // Null because we will define the getter in form
    optionLabelFn: ({ item }) => item.note,
    getInitialArray: (showResponse) => {
      if (!showResponse?.customer_notes) return
      return showResponse.customer_notes.map((item) => {
        return { id: '', note: item }
      })
    },
    trackBy: 'note',
    placeholder: translate(
      t,
      'delivery.noteField.selectCustomerSpecial',
      'Pilih Catatan Khusus Pelanggan'
    ),
    multiple: true,
    taggable: true,
    disabled: true,
  },
  {
    key: 'note',
    name: 'note',
    label: translate(t, 'delivery.noteField.other', 'Catatan Lainnya'),
    placeholder: translate(
      t,
      'delivery.noteField.enterOther',
      'Masukkan catatan lainnya disini...'
    ),
    type: 'textarea',
    disabled: true,
  },
]

const getDeliveryOtherFields = (t, _locale) => ({
  Draf: getDraftFields(t),
  Dikonfirmasi: getDraftFields(t),
  'Menunggu Vendor': getDraftFields(t),
  'Diterima Vendor': getDraftFields(t),
  Ditolak: getDraftFields(t),
  Dijadwalkan: getDraftFields(t),
  'Dijadwalkan Ulang': getDraftFields(t),
  Dijalankan: getStartedFields(t),
  Diambil: getStartedFields(t),
  Terkirim: getStartedFields(t),
  Dibatalkan: getStartedFields(t),
  'Sedang Transit': getStartedFields(t),

  default: getDraftFields(t),
})

export default getDeliveryOtherFields
